export class SostituisciTurnoReperibilitaDTO {
    turnoOrig:number
    turniList:number[]
   
}